import { Link } from '~/shared/components';
import { Favourite } from '~/shared/components/ProductCard/components/Favourite';
import React from 'react';
import { useWishlist } from '~/features/commerce-api/hooks/wishlist/useWishList';
import { Product } from '~/lib/data-contract/salesforce';
import { ImageWrap } from '../styled';
import { getSummeryImage } from '~/utils/image-group-utils';
import { DynamicImageLoader } from '~/shared/components/DynamicImageLoader';

type Props = {
    lineItem: Product;
    onProductClick: (product: Product, index: number) => void;
    index: number;
};

export const ProductImage = ({ lineItem, onProductClick, index }: Props) => {
    const { handleFavourite, isFavorite } = useWishlist();
    const summeryImage = getSummeryImage(lineItem);
    return (
        <Link
            onClick={() => onProductClick(lineItem, index)}
            href={lineItem.c_pageURL}
            title={lineItem.productName}
        >
            <ImageWrap>
                {summeryImage && (
                    <DynamicImageLoader
                        fill
                        sizes="300px"
                        src={summeryImage.link}
                        priority={index < 3}
                        style={{ objectFit: 'contain' }}
                        alt={summeryImage?.alt ?? ''}
                    />
                )}
                <Favourite
                    isFavourite={isFavorite(lineItem.id)}
                    onFavourite={() => handleFavourite(lineItem)}
                />
            </ImageWrap>
        </Link>
    );
};
